import httpClient from '../../httpClient';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { DataRoomMemberNodes } from 'router/subrouters/DataRoom/models/DataRoom';
import { SoftSignalPayload } from 'models/Lead';
import { DataRoomFileBufferPreview } from 'models/File';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';

function getFileBufferPreview(nodeId: string, activeNode = true) {
  return httpClient.get<DataRoomFileBufferPreview>(
    `data-room-${
      activeNode ? 'nodes' : 'node-versions'
    }/${nodeId}/file-buffer-preview`,
  );
}

function startDownloadingFile(
  nodeId: string,
  uniqueId: string,
  activeNode = true,
) {
  return httpClient.get(
    `data-room-${
      activeNode ? 'nodes' : 'node-versions'
    }/${nodeId}/file-buffer-download`,
    {
      params: { uniqueId },
    },
  );
}

function getFolderPath(dataRoomId: string, documentId: string) {
  return httpClient.get<Array<DataRoomNode>>(
    `data-room-nodes/${documentId}/data-rooms/${dataRoomId}/node-path`,
  );
}

function getChildrenForMember(
  dataRoomId: string,
  parentId: string,
  dataRoomMemberId: string,
) {
  return httpClient.get<DataRoomMemberNodes>(
    `data-room-nodes/data-rooms/${dataRoomId}/member-parent-nodes`,
    {
      params: { parentId, dataRoomMemberId },
    },
  );
}

function grantFilesAccessWithoutUndo(dataRoomMemberId: string) {
  return httpClient.post<DataRoomMember>(
    `data-room-members/${dataRoomMemberId}/grant-files-access-without-undo`,
  );
}

function revokeFilesAccessWithoutUndo(dataRoomMemberId: string) {
  return httpClient.post<DataRoomMember>(
    `data-room-members/${dataRoomMemberId}/revoke-files-access-without-undo`,
  );
}

function grantDownloadFilesAccessWithoutUndo(dataRoomMemberId: string) {
  return httpClient.post<DataRoomMember>(
    `data-room-members/${dataRoomMemberId}/grant-download-files-access-without-undo`,
  );
}

function revokeDownloadFilesAccessWithoutUndo(dataRoomMemberId: string) {
  return httpClient.post<DataRoomMember>(
    `data-room-members/${dataRoomMemberId}/revoke-download-files-access-without-undo`,
  );
}

function softSignals(dataRoomNodeId: string, data: SoftSignalPayload) {
  return httpClient.post(`data-room-nodes/${dataRoomNodeId}/soft-signal`, data);
}

export default {
  getFileBufferPreview,
  startDownloadingFile,
  getChildrenForMember,
  getFolderPath,
  softSignals,
  grantFilesAccessWithoutUndo,
  grantDownloadFilesAccessWithoutUndo,
  revokeFilesAccessWithoutUndo,
  revokeDownloadFilesAccessWithoutUndo,
};
